<template>
  <v-container fluid class="container grey lighten-2 text-center" style="height:100%;">
    <v-icon class="mdi-spin mr-2" style="font-size:140px;color:#FF6F00;margin-top:200px;">mdi-settings-outline</v-icon>
  </v-container>
</template>
<script>
import Vue from 'vue'
import { userLoginByWxCode } from '@/plugins/api'
export default {
  data () {
    return {}
  },
  created () {
    let code = this.$route.query.code;
    userLoginByWxCode(code).then(res => {
      let lu = res.data;
      if (!lu) {
        this.$message.error('系统异常,请稍后再试');
        return;
      }
      let token = lu.token;
      if (!token) {
        sessionStorage.setItem('wxUnionId', lu.wxUnionId);
        sessionStorage.setItem('wxPfOpenId', lu.wxPfOpenId);
        this.$router.push('/login/wx/none');
      } else {
        Vue.ls.set('token', lu.token, lu.expireSeconds * 1000);
        this.$store.commit('setToken', lu.token);
        let pwdChgFlag = lu.pwdChgFlag;
        if (!pwdChgFlag) this.$router.push('/first/guide');
        else this.$router.push('/');
      }
    })
  },
  methods: {}
}
</script>